import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { BsShieldCheck, BsLightningFill, BsClockFill } from 'react-icons/bs';

const WhyAIPoweredAgents: React.FC = () => {
  const benefits = [
    {
      icon: <BsShieldCheck size={40} />,
      title: "Licensed Professionals",
      description: "Every agent is fully licensed and vetted"
    },
    {
      icon: <BsLightningFill size={40} />,
      title: "AI-Enhanced Expertise",
      description: "Combining local knowledge with smart technology"
    },
    {
      icon: <BsClockFill size={40} />,
      title: "Faster Results",
      description: "Find perfect matches in hours, not weeks"
    }
  ];

  return (
    <div className="why-ai-agents-section">
      <Container>
        <h2 className="section-title">Real Agents. Smarter Tools. Better Results.</h2>
        
        <div className="trust-message">
          <p className="lead-text">
            We don't replace agents - we empower them. Our partner agents use 
            advanced AI to understand exactly what you're looking for and find 
            properties you might miss on traditional sites.
          </p>
        </div>

        <Row className="benefits-row mt-5">
          {benefits.map((benefit, idx) => (
            <Col key={idx} md={4} className="mb-4">
              <div className="benefit-card text-center">
                <div className="benefit-icon mb-3">{benefit.icon}</div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            </Col>
          ))}
        </Row>

        <div className="trust-banner">
          <p className="banner-text">
            "Where advanced technology meets local expertise"
          </p>
        </div>
      </Container>
    </div>
  );
};

export default WhyAIPoweredAgents;